import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import getContentSummary from '../../../../../../../core/utils/getContentSummary';
import cellStyle from '../PostCell/style';
import summaryStyle from './style';
import PostUserBanner from '../../../../UserBanner/PostUserBanner/PostUserBanner.container';
import TextButton from '../../../../common/Buttons/TextButton';

const SchedulePostsSummary = ({
  scheduledPostCount,
  post,
  openScheduledPosts,
  style,
}) => {
  const [contentSummary, setContentSummary] = useState('');
  useEffect(() => {
    setContentSummary(
      post ? getContentSummary({ content: post.content })[0] : ''
    );
  }, [post]);

  if (!post || scheduledPostCount < 1) {
    return null;
  }

  const viewScheduledLabel =
    scheduledPostCount > 1
      ? `View ${scheduledPostCount} scheduled posts`
      : 'View 1 scheduled post';

  return (
    <div style={{ ...cellStyle.container, ...style }}>
      <div style={cellStyle.cell}>
        <div style={summaryStyle.header}>
          <div style={summaryStyle.title}>Next scheduled post</div>
          <div>
            <TextButton
              label={viewScheduledLabel}
              onClick={openScheduledPosts}
            />
          </div>
        </div>
        <div style={{ ...cellStyle.separator, marginBottom: 16 }} />
        <PostUserBanner post={post} />
        <div style={summaryStyle.content}>{contentSummary}</div>
      </div>
    </div>
  );
};

SchedulePostsSummary.propTypes = {
  scheduledPostCount: PropTypes.number.isRequired,
  post: PropTypes.shape({
    content: PropTypes.string,
  }),
  openScheduledPosts: PropTypes.func.isRequired,
  style: PropTypes.object,
};

SchedulePostsSummary.defaultProps = {
  post: null,
  style: {},
};

export default React.memo(SchedulePostsSummary);
